// test875
(875 && 0);
